<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            color="primary" 
            icon
            x-small
            v-on="{ ...dialog, ...tooltip }"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
      
        <span>Update Company</span>
      </v-tooltip>
    </template>
   
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Claim Request Company"
      text="Update Claim Request Company"
      class="mb-0"
    >
      <template v-if="dialog">
        <v-col 
          cols="12"
          class="mt-n3"
        >
          <v-autocomplete
            v-model="selectedCompany"
            v-validate="'required'"
            label="Company"
            item-text="name"
            item-value="company_uid"
            :items="companies"
            hide-selected
            :error-messages="errors.collect('selectedCompany')"
            data-vv-name="selectedCompany"  
            data-vv-as="company"
          />
        </v-col>
      </template>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"
          class="white--text"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      claimRequest: {
        type: Object,
        required: true,
      },
      company: {
        type: Object,
        required: true,
      },
      companyEmployees: {
        type: Array,
        required: true,
      },
    },  
    data () {
      return {
        dialog: null,
        progressing: false,
        selectedCompany: null,
        companies: [],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return 

        this.companies = _.orderBy(this.companyEmployees.map(ce => {
          return {
            company_uid: ce.company_uid,
            name: ce.company.name,
            start_date: ce.start_date,
            end_date: ce.end_date,
          }
        }), ['name'], ['asc'])

        this.selectedCompany = this.companies.find(c => c.company_uid === this.company.company_uid)
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.claimRequests().updateCompany(this.claimRequest.id, { company_uid: this.selectedCompany })
              .then(response => {
                this.$emit('updated')
                this.$snack({ message: response.data.status })
                this.dialog = false
              })
              .catch((e) => {
                this.$snack({ 
                  color: 'error',
                  message: e.response.data.message,
                })
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
    },
  }
</script>
